import { useCallback, useState } from 'react';

type ProviderType = 'all' | 'system' | 'user';

const USER_TYPE_SELECT_OPTIONS = [
  { label: '전체', value: 'all' },
  { label: '사용자', value: 'user' },
  { label: '시스템', value: 'system' },
];

export const useTagCategorySelect = () => {
  const [selectedType, setSelectedType] = useState<ProviderType>('all');

  const handleSelectType = useCallback((category: ProviderType) => {
    setSelectedType(category);
  }, []);

  return { selectedType, selectOptions: USER_TYPE_SELECT_OPTIONS, handleSelectType };
};
